import { loadQuery } from 'react-relay';
import RelayEnvironment from 'lib/utils/relay';
import { getAccountId } from 'lib/utils/authentication';
import { ACCOUNT_QUERY } from 'services/account/account.relay.services';
import { accountQuery } from 'services/account/__generated__/accountQuery.graphql';
import { COUNTRIES_QUERY } from 'services/country/country.relay.services';
import { countryCountriesQuery } from 'services/country/__generated__/countryCountriesQuery.graphql';

export const SettingsAccountPreloadData = Props => {
  const accountId = getAccountId() ?? '';
  return {
    accountQueryRef: loadQuery<accountQuery>(
      RelayEnvironment,
      ACCOUNT_QUERY,
      {
        id: accountId,
      },
      { fetchPolicy: 'store-or-network' },
    ),
    countriesQueryRef: loadQuery<countryCountriesQuery>(
      RelayEnvironment,
      COUNTRIES_QUERY,
      {
        first: 1000,
      },
      { fetchPolicy: 'store-or-network' },
    ),
  };
};

export type SettingsAccountTypePreloadDataType = ReturnType<typeof SettingsAccountPreloadData>;
